import { useCallback, useMemo } from 'react'
import { useBiAuth } from '../state/BiAuthContext'
import {
  normalizePaineis,
  type PanelAccess,
  type PanelId,
  type PaineisMap,
} from './panels'

export function usePanelAccess() {
  const { user } = useBiAuth()
  const tipo = user?.tipo === 'admin' || user?.tipo === 'leitura' ? user.tipo : 'usuario'

  const paineis: PaineisMap = useMemo(
    () => normalizePaineis(user?.paineis, tipo),
    [user?.paineis, tipo],
  )

  const isAdmin = tipo === 'admin'

  const access = useCallback(
    (id: PanelId | string): PanelAccess => {
      if (isAdmin) return { ver: true, escrever: true }
      return paineis[id] || { ver: false, escrever: false }
    },
    [isAdmin, paineis],
  )

  const canView = useCallback((id: PanelId | string) => access(id).ver, [access])
  const canWrite = useCallback((id: PanelId | string) => access(id).escrever, [access])

  return { isAdmin, paineis, access, canView, canWrite, tipo }
}
